import { render, staticRenderFns } from "./SalesDocQuery.vue?vue&type=template&id=f24ce3a6&scoped=true"
import script from "./SalesDocQuery.vue?vue&type=script&lang=js"
export * from "./SalesDocQuery.vue?vue&type=script&lang=js"
import style0 from "./SalesDocQuery.vue?vue&type=style&index=0&id=f24ce3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24ce3a6",
  null
  
)

export default component.exports